import { Button, ChevronDownIcon } from '@mr-yum/frontend-ui'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { CartValidator } from '@/components/Cart/validation'
import { TableNumberLabel } from '@/components/TableNumber/TableNumberLabel'
import { useLoggerLegacy } from '@/hooks/useLogger'

import { useSheetToggle } from './utils/sheetUtils'

interface Props {
  cart?: CartValidator | null
  tableShortText?: string
  isTableTurnedOff?: boolean
  tableNumber?: string | null
  hasNoPaths?: boolean
  hasTableNumberPaths?: boolean
}

export const TableNumberButton = ({
  cart,
  tableShortText,
  isTableTurnedOff,
  hasNoPaths,
  tableNumber,
  hasTableNumberPaths,
}: Props) => {
  const { logEventLegacy } = useLoggerLegacy()
  const sheetToggle = useSheetToggle()
  const intl = useIntl()

  const handleOnClick = useCallback(() => {
    logEventLegacy('Clicked on table number selector')
    void sheetToggle({
      sheet: 'table-number',
    })
  }, [logEventLegacy, sheetToggle])

  if (hasNoPaths) {
    return null
  }

  const isWithTable = !isTableTurnedOff
  const hasTableNumberLabel = tableNumber && !hasTableNumberPaths

  if (!isWithTable) {
    return null
  }

  return (
    <div className="my-body-sm">
      <Button
        type="button"
        variant="link-primary"
        className="min-h-5 items-center gap-0 text-left"
        size="sm"
        aria-label={intl.formatMessage({
          defaultMessage: 'Select table number',
          id: 's7CkJR',
        })}
        onClick={handleOnClick}
        rightIcon={
          <ChevronDownIcon width={20} height={20} className="flex-shrink-0" />
        }
      >
        {hasTableNumberLabel ? (
          <TableNumberLabel
            shortText={tableShortText}
            number={tableNumber}
            area={cart?.tableArea}
          />
        ) : (
          'Select table number'
        )}
      </Button>
    </div>
  )
}
